import * as React from 'react';
import Styles from './Satesto.module.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Satesto = () => {
  // const [isVisible, setIsVisible] = useState(false);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();


    const data = [
      { id: 1, name: 'Toyota', description: 'A reliable car from Japan' },
    { id: 2, name: 'BMW', description: 'A luxury car from Germany' },
    { id: 3, name: 'Audi', description: 'High-performance car from Germany' },
    { id: 4, name: 'Mercedes', description: 'A premium car from Germany' },
    ];

     // State-ი, რათა შევინახოთ არჩეული მანქანის მოდელი
  const [selectedModel, setSelectedModel] = useState('');
  const navigate = useNavigate(); // მარშრუტიზაციისთვის


  // handleChange ფუნქცია, რომელიც განახლებს selectedModel- ს
  const handleChange = (e) => {
    setSelectedModel(e.target.value);
  };

  const handleSubmit = () => {
    if (selectedModel) {
      // გადადიხარ კონკრეტული მანქანის გვერდზე, მოდელი როგორც პარამეტრი
      navigate(`/car/${selectedModel}`);
    }
  };

  
  return (
    <form className={Styles.forma}>
      <br></br>
      <br></br><br></br><br></br><br></br><br></br><br></br>
      <div className={Styles.form_sort}>

        <div className={Styles.input_enter} >
          <input className={Styles.dizain_date}
            
            type="text"
            placeholder="First Name *"
          >

          </input>
        </div>
        <div className={Styles.input_enter}>
          <input className={Styles.dizain_date}
            type="text"
            placeholder="Last Name *"

          />
        </div>

        <div className={Styles.input_enter}>
          <select className={Styles.dizain_select_age}
            name="pets"
            id="pet-select"
          >
            <option value="">Age *</option>
            <option value="25">25-30</option>
            <option value="24">30-35</option>
            <option value="23">35-40</option>
            <option value="22">40+</option>

          </select>
        </div>
      </div>




      <div className={Styles.form_sort}>
        <div className={Styles.input_enter}>
          <select
            className={Styles.dizain_select}
            name="office" id="set-office"
          >
            <option value="">Enter your pick-up location *</option>
            <option value="Tbilisi Office">Tbilisi Office</option>
            <option value="Tbilisi Airport">Tbilisi Airport a</option>
            <option value="Qutaisi Office">Qutaisi Office</option>
            <option value="Batumi Office">Batumi Office</option>
          </select>
        </div>
        <div className={Styles.input_enter}>
          <input className={Styles.dizain_date}
            type='date'
          >

          </input>
        </div>
        <div className={Styles.input_enter}>
          <input className={Styles.dizain_time} type='time'
          ></input>
        </div>
      </div>



      
        <div >





          <div className={Styles.form_sort}>
            <div className={Styles.input_enter}>
              <select
                className={Styles.dizain_select}
                name="pets"
                id="pet-select"
              >
                <option value="">Return location *</option>
                <option value="Tbilisi Office">Tbilisi Office</option>
                <option value="Tbilisi Airport">Tbilisi Airport a</option>
                <option value="Qutaisi Office">Qutaisi Office</option>
                <option value="Batumi Office">Batumi Office</option>
              </select>
            </div>
            <div className={Styles.input_enter}>
              <input
                className={Styles.dizain_date}
                type="date"
              >
              </input>
            </div>
            <div className={Styles.input_enter}>
              <input
                className={Styles.dizain_time}
                type='time'
              ></input>
            </div>
          </div>
          <div className={Styles.form_sort}>
            <div className={Styles.input_enter}>
              <select 
                value={selectedModel} onChange={handleChange}
                className={Styles.dizain_select_age}
              >
                <option value="" disabled>Select car *</option>
                {data.map((car) => (
          <option key={car.id} value={car.name}>
            {car.name}
          </option>
        ))}
                {/* <option value="Hyundai Tucson">Hyundai Tucson</option>
                <option value="Hyundai Creta">Hyundai Creta</option>
                <option value="Nissan Micra">Nissan Micra</option>
                <option value="Renault Daster">Renault Daster</option>
                <option value="Renault Logan">Renault Logan</option>
                <option value="Renault Sandero">Renault Sandero</option>
                <option value="Toyota Corolla">Toyota Corolla</option>
                <option value="Toyota Fortuner">Toyota Fortuner</option>
                <option value="Toyota Prado">Toyota Prado</option>
                <option value="Toyota Yarus">Toyota Yarus</option>
                <option value="Toyota Rav4">Toyota Rav4</option> */}

              </select>
             
            </div>
            <div className={Styles.input_enter}>
              <input className={Styles.dizain_date}
                type="email"
                placeholder="Your Email *"
              >
              </input>
            </div>
            <div className={Styles.input_enter_btn}>
              <button type="submit" onClick={handleSubmit} >SELECT MY CAR</button>

            </div>
          </div>









        </div>
        <p>არჩეული მოდელი: {selectedModel}</p>
    </form>
  )
}

export default Satesto
